import usePrefix from '@/hooks/usePrefix';
import React from 'react';
import BicesterCardInput from './Input';
import BicesterCardPicker from './Picker';
import BicesterCardCheckPicker from './CheckPicker';
import BicesterCardDatePicker from './DatePicker';
import BicesterCardDateRangePicker from './DateRangePicker';
import BicesterCardPickerWithCheck from './PickerWithCheck';
import BicesterCardCityPicker from './CityPicker';
import BicesterCardCheckbox from './Checkbox';
import BicesterCardInputNumber from './InputNumber';

/**
 * Card组件的外层需要套formik-rsuite的Form组件配合使用
 * @param param0
 * @returns
 */
const BicesterCard = ({
  title,
  horizontal = false,
  smDivider = false,
  className,
  style,
  children,
}: {
  title?: React.ReactNode;
  horizontal?: boolean;
  smDivider?: boolean;
  className?: string;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  [rest: string]: any;
}) => {
  const { prefix, classname } = usePrefix('bicester-card');

  return (
    <div className={`${classname} ${className || ''}`} style={style}>
      {title && <div className={prefix('header')}>{title}</div>}
      <div
        className={`${prefix('body')} ${horizontal ? 'horizontal' : ''} ${
          smDivider ? 'sm-divider' : ''
        } ${title ? 'py-[12px]' : 'py-0'}`}
      >
        {children}
      </div>
    </div>
  );
};

BicesterCard.Input = BicesterCardInput;
BicesterCard.InputNumber = BicesterCardInputNumber;
BicesterCard.Picker = BicesterCardPicker;
BicesterCard.Checkbox = BicesterCardCheckbox;
BicesterCard.CheckPicker = BicesterCardCheckPicker;
BicesterCard.DatePicker = BicesterCardDatePicker;
BicesterCard.DateRangePicker = BicesterCardDateRangePicker;
BicesterCard.CityPicker = BicesterCardCityPicker;
BicesterCard.PickerWithCheck = BicesterCardPickerWithCheck;

export default BicesterCard;
